var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.83 114.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#06d386;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.71,114.56l-29.09.1c-.93,0-1.79-.49-2.25-1.29L.16,59.31c-.47-.81.11-1.81,1.05-1.82l30.02-.07c.43,0,.84.23,1.05.61l31.48,54.71c.46.81-.12,1.81-1.04,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.63,57.3l-29.09.1c-.93,0-1.79-.49-2.25-1.29L67.08,2.06c-.47-.81.11-1.81,1.05-1.82l30.02-.07c.43,0,.84.23,1.05.61l31.48,54.71c.46.81-.12,1.81-1.04,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.57.15L33.99,0c-1.04-.01-2,.53-2.53,1.42l-6.57,11.12c-.53.9-.54,2.02-.01,2.93l56.57,97.74c.52.9,1.47,1.45,2.51,1.45h12.44c1.02,0,1.97-.54,2.49-1.42l6.53-10.97c.54-.9.54-2.02.02-2.93L49.04,1.6c-.51-.89-1.45-1.44-2.47-1.45Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-icon.c0f9ab05a5ae966b1daafe8152cb9923.svg";